import { Box, Typography } from '@mui/material'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import PersonalityInfoModal from 'module/recruitment/pages/recruitment-manage-applicant/components/PersonalityInfoModal'
import RadarChart from 'module/recruitment/pages/recruitment-manage-applicant/components/RadarChart'
import React, { useEffect, useState } from 'react'
import PersonalitySideBar from '../components/PersonalitySideBar'
import SimilarityScoreDrawer from '../components/SimilarityScoreDrawer'
import InvitePersonalityTestModal from '../components/InvitePersonalityTestModal'

const WorkPersonalityFitAnalysis = () => {
  //modal
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const [showScore, setShowScore] = useState(false)
  const [evaluateTeamData, setEvaluateTeamData] = useState(null)

  const handleTeamData = (data) => {
    if (data.combinedArray.length === 0) {
      handleResetData()
    }
    setEvaluateTeamData(data)
  }

  const [userData, setUserData] = useState({
    labels: ['FREEDOM (%)', 'ADVENTUROUS (%)', 'TEAMWORK (%)', 'SYSTEMATIC (%)', 'AMBITIOUS (%)'],
    datasets: [],
  })

  const chartColors = [
    'rgba(245, 210, 22)',
    'rgba(9, 163, 169)',
    'rgba(126, 61, 121)',
    'rgba(32, 81, 238)',
    'rgba(255, 92, 0)',
    'rgba(239, 171, 255)',
  ]
  const chartBackgroundColors = [
    'rgba(245, 210, 22, 0.2)',
    'rgba(9, 163, 169, 0.2)',
    'rgba(126, 61, 121, 0.2)',
    'rgba(32, 81, 238, 0.2)',
    'rgba(255, 92, 0, 0.2)',
    'rgba(239, 171, 255, 0.2)',
  ]

  const handleResetData = () => {
    setUserData({
      labels: ['FREEDOM (%)', 'ADVENTUROUS (%)', 'TEAMWORK (%)', 'SYSTEMATIC (%)', 'AMBITIOUS (%)'],
      datasets: [],
    })
  }

  const hasBenchmark = !!evaluateTeamData?.benchmark

  useEffect(() => {
    if (evaluateTeamData?.combinedArray.length > 0) {
      const mappedData = evaluateTeamData?.combinedArray?.map((user, index) => ({
        data: [
          user?.personality_traits?.freedom?.dominant_percentage ??
            user?.personality_traits?.freedom?.average_percentage,
          user?.personality_traits?.adventurous?.dominant_percentage ??
            user?.personality_traits?.adventurous?.average_percentage,
          user?.personality_traits?.teamwork?.dominant_percentage ??
            user?.personality_traits?.teamwork?.average_percentage,
          user?.personality_traits?.systematic?.dominant_percentage ??
            user?.personality_traits?.systematic?.average_percentage,
          user?.personality_traits?.ambitious?.dominant_percentage ??
            user?.personality_traits?.ambitious?.average_percentage,
        ],
        backgroundColor: `${
          chartBackgroundColors[(index + (hasBenchmark ? 0 : 1)) % chartBackgroundColors.length]
        }`,
        borderColor: chartColors[(index + (hasBenchmark ? 0 : 1)) % chartColors.length],
        borderWidth: 3,
      }))

      setUserData((prevData) => ({
        ...prevData,
        datasets: mappedData,
      }))
    }
  }, [evaluateTeamData])

  return (
    <DashboardContainer headerTitle="Work Personality Fit">
      <Box
        sx={{
          backgroundColor: 'white.main',
          width: '100%',
          display: 'flex',
          height: '100%',
          border: 1,
          borderColor: 'gray-line.main',
          borderRadius: '4.5px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            padding: '24px',
            borderRight: 1,
            borderRightColor: 'gray-line.main',
            width: '60%',
          }}
        >
          <InvitePersonalityTestModal
            open={open}
            handleCloseModal={handleClose}
            handleOpenModal={handleOpen}
          />
          <Typography variant="h4" fontWeight={600}>
            Work personality fit analysis
          </Typography>
          <Typography variant="body1">
            Get valuable insight of your staff from their work personality assessment and compare
            across all staff and departments.
          </Typography>
          <PersonalityInfoModal variant="module" />

          <Box
            sx={{
              height: '600px',
              maxHeight: '411px',
              // paddingX: '33px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <RadarChart chartData={userData} custom={true} hasBenchmark={hasBenchmark} />
          </Box>
          {evaluateTeamData?.benchmark && evaluateTeamData?.compareArray.length > 0 && (
            <Box
              display="flex"
              gap="24px"
              justifyContent="space-between"
              alignItems="center"
              bgcolor="gray-background.main"
              padding="12px"
              margin="24px"
              borderRadius="4.5px"
            >
              <Typography sx={{ opacity: showScore ? 0.4 : 1 }}>
                {`Similarity score compared to `}
                <span style={{ fontWeight: 500, opacity: showScore ? 0.4 : 1 }}>
                  {evaluateTeamData?.benchmark?.name}
                </span>
              </Typography>
              <Typography
                sx={{
                  cursor: 'pointer',
                  color: showScore ? 'error.main' : 'green-01.main',
                  textDecoration: 'underline',
                }}
                onClick={() => setShowScore(!showScore)}
              >
                {showScore ? 'Close tab' : `View (${evaluateTeamData?.compareArray.length})`}
              </Typography>
            </Box>
          )}
        </Box>

        <Box sx={{ width: '40%' }}>
          {showScore && (
            <SimilarityScoreDrawer
              scoreData={evaluateTeamData}
              onClose={() => setShowScore(!showScore)}
            />
          )}
          <PersonalitySideBar
            evaluateTeamData={handleTeamData}
            showScore={showScore}
            handleOpenModal={handleOpen}
          />
        </Box>
      </Box>
    </DashboardContainer>
  )
}

export default WorkPersonalityFitAnalysis
